import React, { useEffect, useState, Fragment } from 'react';
import "./AddOrEditRole.css"
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { toast } from 'react-toastify';
import { getRole, addRole, getRoles, updateRole, getPermissionsOfCategory } from '../../services/http';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import SelectSearch from 'react-select-search';
import { handleMenuSelection, handleSubMenuSelection } from '../../utils/utils';
import Navbar from '../../appShell/Navbar/Navbar';
import Sidebar from '../../appShell/Sidebar/Sidebar';
import { Accordion } from "react-bootstrap"
import { MdArrowDropDownCircle } from "react-icons/md"
import CustomAccordion from '../CustomAccordion/CustomAccordion';
import Loader from '../Loader/Loader';
import ProcessSpinner from '../ProcessSpinner/ProcessSpinner';

const AddOrEditRole = (props) => {


  const { operationType } = props;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const id_role = useParams();
  const states = useSelector((state) => state, shallowEqual);

  const [displayLoader, setDisplayLoader] = useState(operationType == "new" ? false : true);
  const [processOngoing, setProcessOngoing] = useState(false)
  const [showErrorLibelle, setShowErrorLibelle] = useState(false)
  const [showErrorPermission, setShowErrorPermission] = useState(false)
  const [roleLabel, setRoleLabel] = useState("")
  const [roleIsDefault, setRoleIsDefault] = useState()
  const [libelleErrorMessage, setLibelleErrorMessage] = useState("")
  const [permissionErrorMessage, setPermissionErrorMessage] = useState("")

  // To populate the breadcrumb and update the sidebar menu
  useEffect(() => {
    let type;
    if (operationType == "new") { type = "Ajout" } else if (operationType == "edit") { type = "Modification" } else { type = "Visualisation" }
    dispatch({
      type: "SET",
      key: "breadcrumbContent",
      payload: {
        firstLevelText: "Paramètres", firstLevelLink: "", secondLevelText: "Roles", secondLevelLink: "/role", thirdLevelText: type, thirdLevelLink: ""
      }
    });
    handleMenuSelection("settings", dispatch, states);
    handleSubMenuSelection("roles", dispatch)
  }, [])
  const loadRoleData = async () => {
    const resp = await getRole(id_role, states.userToken.access_token)
    if (resp.response && resp.response.status !== 200) {
      console.log("data error ", resp.response)
    } else {
      setRoleLabel(resp.data?.role?.name)
      var isDefault;
      if (resp.data?.role?.isDefault == 1) {
        setRoleIsDefault(true)
      } else {
        setRoleIsDefault(false)
      }
      console.log("Top edit", resp.data)
      var permissionsAlreadyAdded = [...resp.data.role.permissions]
      var allPermissions = [...resp.data.categoryPermission]

      allPermissions.map(cat => {
        cat.permissions.map(permissionAvailable => {
          permissionsAlreadyAdded.map(permissionAdded => {
            // console.log("permissionAdded ", permissionAdded)
            // console.log("permissionAvailable ", permissionAvailable)
            permissionAvailable.addedToRole = false;
          })
        })
      })

      allPermissions.map(cat => {
        cat.permissions.map(permissionAvailable => {
          permissionsAlreadyAdded.map(permissionAdded => {
            if (permissionAdded.id == permissionAvailable.id) {
              // console.log("permissionAdded ", permissionAdded)
              // console.log("permissionAvailable ", permissionAvailable)
              permissionAvailable.addedToRole = true;

            }
          })
        })
      })
      allPermissions.map(role => {
        role.allAdded = false
        role.permissions.map(permission => {
          if (permission.addedToRole == true) {
            role.openedOnEdit = true
          }
        })
        console.log("Top role ====> ", role)

      })
      // console.log("data data ", allPermissions)        
      setDisplayLoader(false)
    }
    // console.log(resp.data)
    dispatch({
      type: "SET",
      key: "allPermissions",
      payload: allPermissions,
    });


    // console.log(states.allPermissions)

  }

  useEffect(() => {
    if (roleLabel !== "") {
      setShowErrorLibelle(false)
    }
  }, [roleLabel])


  const handleChangeLabel = (e) => {
    var value = e.currentTarget.value;
    setRoleLabel(value);
  }

  const handleAddRole = async (type) => {
    setProcessOngoing(true)
    let values = [];
    states.allPermissions && states.allPermissions.map(item => {
      item.permissions.map(permission => {
        if (permission.addedToRole === true) {
          values.push(permission.id)
        }
      })

    })
    console.log((values))
    const data = {
      name: roleLabel,
      permission: values.length === 0 ? "" : values
    }

    const reqdata = await addRole(states.userToken.access_token, data);
    console.log(reqdata)
    if (reqdata.response && reqdata.response.status !== 200) {
      if (reqdata.response.status === 422) {
        setProcessOngoing(false)
        console.log(reqdata.response.data.error["name"])
        if (reqdata.response?.data.error["name"]) {
          var errorMsg1 = reqdata.response?.data.error["name"][0];
          setShowErrorLibelle(true)
          setLibelleErrorMessage(errorMsg1)
          toast.error(errorMsg1, {
            position: toast.POSITION.TOP_RIGHT
          });

        }
        if (reqdata.response?.data.error["permission"]) {
          var errorMsg1 = reqdata.response?.data.error["permission"][0];
          setShowErrorPermission(true)
          setPermissionErrorMessage(errorMsg1)
          toast.error(errorMsg1, {
            position: toast.POSITION.TOP_RIGHT
          });
        }
      } else {
        console.log(reqdata.response?.data.error)
        toast.error(reqdata.response?.data.error, {
          position: toast.POSITION.TOP_RIGHT
        });
      }
    } else {
      setProcessOngoing(false)
      toast.success(`Nouveau Role ${roleLabel} ajouté avec succès !`, {
        position: toast.POSITION.TOP_RIGHT
      });
      setRoleLabel("")
      loadRolesPermissions();
      // dispatch({
      //   type: "SET",
      //   key: "allPermissions",
      //   payload: [],
      // });
      if (type == "retourner") { navigate("/role") }



    }

  }

  const handleEditRole = async () => {
    setProcessOngoing(true)
    console.log("idRole", id_role)
    let values = [];
    states.allPermissions && states.allPermissions.map(item => {
      item.permissions.map(permission => {
        if (permission.addedToRole === true) {
          values.push(permission.id)
        }
      })

    })
    console.log((values))
    const data = {
      name: roleLabel,
      permission: values
    }

    const reqdata = await updateRole(id_role, data, states.userToken.access_token);
    if (reqdata.response && reqdata.response.status !== 200) {
      if (reqdata.response.status === 422) {
        setProcessOngoing(false)
        // console.log(reqdata.response?.data.error["mane"][0].length)
        if (reqdata.response?.data.error["name"]) {
          var errorMsg1 = reqdata.response?.data.error["name"][0];
          setShowErrorLibelle(true)
          setLibelleErrorMessage(errorMsg1)
          toast.error(errorMsg1, {
            position: toast.POSITION.TOP_RIGHT
          });
        }
        if (reqdata.response?.data.error["permission"]) {
          var errorMsg1 = reqdata.response?.data.error["permission"][0];
          setShowErrorPermission(true)
          setPermissionErrorMessage(errorMsg1)
          toast.error(errorMsg1, {
            position: toast.POSITION.TOP_RIGHT
          });
        }
      } else {
        console.log(reqdata.response)
        toast.error(reqdata.response?.data.error, {
          position: toast.POSITION.TOP_RIGHT
        });
      }
    } else {
      setProcessOngoing(false)
      toast.success(`Rôle modifié avec succès !`, {
        position: toast.POSITION.TOP_RIGHT
      });

      dispatch({
        type: "SET",
        key: "allPermissions",
        payload: [],
      });
      navigate("/role")


    }
  }

  const handleBack = () => {
    navigate("/role")
  }


  const loadRolesPermissions = async () => {
    const resp = await getPermissionsOfCategory(states.userToken.access_token);
    if (resp.response && resp.response.status !== 200) {
      console.log("data error ", resp.response)
    } else {

      //  let responseArrayCoppy = [...resp.data]
      resp.data.map(role => {
        role.permissions.map(permission => {
          permission.addedToRole = false
        })
      })
      resp.data.map(role => {
        role.allAdded = false

      })

      console.log("Top", resp.data)
      dispatch({
        type: "SET",
        key: "allPermissions",
        payload: resp.data,
      });

    }
  }

  useEffect(() => {
    if (operationType == "new") {
      loadRolesPermissions();
    } else {
      loadRoleData();
    }
  }, [])


  return (
    <div>
      <Navbar />
      <div className="main-container" id="container">
        <Sidebar />

        <div id="content" className="main-content">
          <div className="layout-px-spacing">

            <div className="row layout-top-spacing">
              <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
              </div>
            </div>
            {displayLoader == false ?
              <div className="widget widget-content widget-content-area mt-3">
                <div className="pl-3 mx-auto">
                  <h5 className="modal-title pt-3 mb-1 text-left" id="exampleModalLabel">{operationType == "new" ? "Nouveau Rôle" : operationType == "edit" ? "Modifier Rôle" : "Visualiser Rôle"}</h5>
                </div>
                <hr />
                <div className="">
                  {/* {roleIsDefault && roleIsDefault == true ? <div className="py-2 mb-2 w-80 mx-auto rounded" style={{border: "2px solid yellow", backgroundColor: "#FCE936"}}>Vous êtes sur le point de modifier un rôle prédéfini</div> : null} */}
                  <div class="form-group row w-80 mx-auto mb-4">
                    <label for="libelle" class="col-sm-2 col-form-label col-form-label-sm text-dark required">Libellé</label>
                    <div class="col-sm-10">
                      <input type="text" style={{ fontWeight: 600 }} disabled={roleIsDefault} onChange={(e) => handleChangeLabel(e)} className={showErrorLibelle == true ? "form-control custom-form-control form-control-sm new-institution-error-input text-dark mx-auto" : "form-control text-dark custom-form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={roleLabel} required />
                      {showErrorLibelle == true && <span className="new-institution-error-span">{libelleErrorMessage}</span>}
                      {/* {showErrorPermission == true && <span className="new-institution-error-span">{permissionErrorMessage}</span>} */}
                    </div>
                  </div>
                  <div class="w-80  mb-4 mx-auto">
                    <div id="toggleAccordion">
                      {states.allPermissions ? (states.allPermissions).map((role, index) =>
                        <CustomAccordion roleIsDefault={roleIsDefault}
                          key={`${role}-${index}`}
                          operationType={operationType}
                          id={role?.id}
                          title={role?.libelle}
                          allAdded={role?.allAdded}
                          openedOnEdit={role?.openedOnEdit}
                          permissions={role?.permissions} />

                      ) : <h1 className="py-2">Aucun Role Disponible</h1>}
                    </div>
                  </div>



                </div>

                <div className="new-institution-custom-modal-footer w-90 pb-3">
                  {processOngoing == false ? <Fragment>
                    {operationType !== "view" && <button
                      title={operationType == "new" ? "Ajouter et rester sur la page" : "Modifier"}
                      type="button" className="btn btn-primary ml-3" onClick={operationType == "new" ? () => handleAddRole("rester") : handleEditRole}>{operationType == "new" ? "Ajouter et Nouveau" : "Modifier"}</button>}
                    {operationType == "new" &&
                      <button type="button"
                        title={"Ajouter et retourner à la liste"}
                        className="btn btn-primary ml-3"
                        onClick={() => handleAddRole("retourner")}>
                        Ajouter et Retourner</button>
                    }
                  </Fragment> : <ProcessSpinner />}
                  <button className="btn ml-3" data-dismiss="modal" onClick={handleBack}><i className="flaticon-cancel-12"></i> Retour</button>

                </div>
              </div> : <div style={{ marginTop: "25%" }}>
                <Loader />
              </div>}
          </div>

        </div>
      </div>
    </div>
  )
}

export default AddOrEditRole